
<template>
  <!--添加api-->
  <div>
    <x-addEdit
      :formList="formList"
      :formKey="formKey"
      :addParam="addParam"
      :editParam="editParam"
      :detailParam="detailParam"
    >
    </x-addEdit>
  </div>
</template>
<script>
import { fetchSelect } from '../../../utils/mixins';
export default {
  mixins: [fetchSelect],
  name: 'addApi',
  data () {
    let decoratorOptions = {
      title: {
        rules: [{required: true, message: '请输入菜单名称'}]
      },
      route: {
        rules: []
      },
      description: {
        rules: [{min: 2, max: 20, message: '描述为2-20个字'}]
      },
      module: {
        rules: []
      },
      method: {
        rules: []
      }
    };
    return {
      formList: [
        {
          label: '菜单名称',
          inputType: 'input',
          options: [],
          placeholder: '请输入名称',
          props: ['title', decoratorOptions.title]
        },
        {
          label: '路由名称',
          inputType: 'input',
          options: [],
          placeholder: '请输入路由名称',
          props: ['route', decoratorOptions.route]
        },
        {
          label: '分类',
          inputType: 'cascader',
          options: [],
          placeholder: '请选择分类',
          changeOnSelect: true,
          handle: this.categoryChange,
          props: ['module', decoratorOptions.module]
        },
        {
          label: '父级',
          inputType: 'cascader',
          options: [],
          placeholder: '请选择父级',
          changeOnSelect: true,
          props: ['parent_id', {rules: []}]
        },
        {
          label: '请求方法',
          inputType: 'select',
          options: [
            { label: 'GET', value: 'GET' },
            { label: 'POST', value: 'POST' },
            { label: 'PUT', value: 'PUT' },
            { label: 'DELETE', value: 'DELETE' }
          ],
          placeholder: '请选择请求方法',
          props: ['method', decoratorOptions.method]
        },
        {
          label: '描述',
          inputType: 'textarea',
          options: [],
          placeholder: '请输入描述',
          props: ['description', decoratorOptions.description]
        }
      ],
      formKey: {
        title: '',
        route: '',
        module: '',
        parent_id: '',
        method: '',
        description: ''
      },
      addParam: {
        url: 'apis',
        reqHandle: '', // this.reqHandle
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '/apis/',
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '/apis/',
        resHandle: this.detailResHandle
      }
    };
  },
  mounted () {
    // let paramArr = [{index: 3, key: 'category', scope: 'formList'}];
    // let query = { category_module: this.$store.state.categoryAddModule['addApiCate'], children_number: 2 };
    // this.deviceManageSelect(paramArr, query);
    this.getSelect();
  },
  methods: {
    getSelect () {
      /* 获取api分类 */
      this.$get({
        url: '/apis/get_category',
        params: {}
      }).then(({data}) => {
        this.formList[2].options = data;
      });
    },
    /* 分类change事件 */
    categoryChange (val) {
      /* 获取api树 */
      this.$get({ // parent_id字段使用
        url: '/apis/get_apis_tree',
        params: { category: val[0] }
      }).then(({data}) => {
        this.formList[3].options = data;
      });
    },

    addResHandle (res) {
      console.log('处理添加返回数据: ', res);
      return res;
    },
    reqHandle (param) {
      console.log('处理请求前数据: ', param);
      return param;
    },
    detailResHandle (data) {
      data.module && data.module.length && this.categoryChange(data.module);
      return data;
    },
    editResHandle (res) {
      console.log('处理编辑返回数据: ', res);
      return res;
    }
  }
};
</script>
